module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_photowedding-99cb1e8cbfcd51e0835e5c440492aee0.webp";